import React from "react";

export default function LoaderComponent() {
  var headerElm: HTMLElement | null = document.querySelector(".header-wrapper");
  var headerHeight = headerElm ? headerElm.offsetHeight : 0;
  var breadcrumbsElm: HTMLElement | null = document.querySelector(
    ".breadcrumbs-section"
  );
  var breadcrumbsHeight = breadcrumbsElm
    ? breadcrumbsElm.offsetHeight + 100
    : 0;
  var height = headerHeight + breadcrumbsHeight;
  return (
    <div
      className="loader-container"
      style={{
        height: `calc(100vh - 380px)`,
      }}
    >
      <div className="loader"></div>
    </div>
  );
}
